import { forwardRef } from 'react';
import { Menu as MuiMenu, MenuItem as MuiMenuItem } from '@mui/material';

/**
 * Menu — dropdown popover with a list of items.
 * MenuItem — a single row inside a Menu.
 *
 * Thin MUI wrappers; replace internals later without touching callers.
 */
export const Menu = forwardRef((props, ref) => <MuiMenu ref={ref} {...props} />);
Menu.displayName = 'Menu';

export const MenuItem = forwardRef((props, ref) => <MuiMenuItem ref={ref} {...props} />);
MenuItem.displayName = 'MenuItem';

export default Menu;
